export const AUTH_ROLES = {
    CASHIER:'cashier',
    ADMIN: 'admin',
    SUPER_ADMIN:'superAdmin',
    WAITER:'waiter',
    KITCHEN: 'kitchen',
    MANAGER: "manager"
}